// import { DriverModel, ID, Response } from "../../../../../_metronic/helpers"

import { DriverModel, ID, Response } from "../../../../../_metronic/helpers"

// import {ID, Response} from '../../../../../../_metronic/helpers'
export type Driver = {
  id?: ID
  name?: string
  driver_name?: string
  avatar?: string
  email?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type DriversQueryResponse = Response<Array<DriverModel>>

export const initialDriver: Driver = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}
